/**
 * Tipos de toast disponibles
 */
export type ToastType = 'success' | 'error' | 'warning' | 'info';

/**
 * Interfaz para un mensaje toast
 */
export interface ToastMessage {
  id: string;
  message: string;
  type: ToastType;
  delay?: number;
  autohide?: boolean;
}

/**
 * Configuración de iconos por tipo de toast
 */
export const TOAST_ICONS: Record<ToastType, string> = {
  success: 'check_circle',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

/**
 * Configuración de clases CSS por tipo de toast
 */
export const TOAST_CLASSES: Record<ToastType, string> = {
  success: 'bg-success',
  error: 'bg-danger',
  warning: 'bg-warning',
  info: 'bg-info',
};
